import { createSlice } from "@reduxjs/toolkit";
const storedAuth = localStorage.getItem("auth");
const initialState = storedAuth ? JSON.parse(storedAuth) : { userData: null };

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      state.userData = action.payload;
      localStorage.setItem("auth", JSON.stringify(state));
    },
    removeCurrentUser: (state, action) => {
      state.userData = null;
      localStorage.removeItem("auth");
      localStorage.removeItem("accessToken");
    },
  },
});

export const { setCurrentUser, removeCurrentUser } = authSlice.actions;
export default authSlice.reducer;
